// extracted by mini-css-extract-plugin
export default {"container":"W8_tnR","column":"_FnANX","video":"BLt5Cz","videoHeading":"Z6F0Lj","videoQuote":"CWw33K"};